const Settings = () => {
};

export default Settings;